/**
 * Get hex colors from string
 * @param str Color string
 * @returns Hex color
 *
 * @example
 * ```ts
 * getHexColorsFromString('#000'); // ['#000']
 * ```
 */
export const getHexColorsFromString = (str: string) => {
	// eslint-disable-next-line security/detect-unsafe-regex
	return str.match(/^#((?:[a-f0-9]{1,2}){3})$/i);
};

export default getHexColorsFromString;
